export default __webpack_public_path__ + "static/uswitch.url-067477216e630a52c8b4dad8f357a9e6.svg";